import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">ANASS BOUCHFAR </span>, Business Intelligence & Analytics Engineer Student
            from <span className="purple">ENSIAS </span>- RABAT Morocco,
            <br />I am a junior <span className="purple">Laravel & VueJs developer</span>.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing GameS
            </li>
            <li className="about-activity">
              <a rel="noreferrer" target="_blank" href="https://medium.com/@anass.bouchfar22" style={{color:"#fff"}}> <ImPointRight /> Writting Tech Blogs</a>
            </li>
            <li className="about-activity">
              <ImPointRight /> Swimming
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "programming is thinking not typing !"{" "}
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
